import React from 'react';
import './Day1.css';
import Footer from '../Footer/Footer';

function Day1() {
  return (
    <div className='day1'>
      <div className='prog_header'>
        <h1 className='prog_header_kippra'>6TH KIPPRA ANNUAL REGIONAL CONFERENCE</h1>
        <h1 className='prog_header_theme'>THEME: ACCELERATING ECONOMIC GROWTH AND DEVELOPMENT FOR ASALS IN </h1>
        <h1 className='prog_header_theme'>KENYA</h1>
      </div>
      <div>
        <table>
          <thead>
            <tr>
              <th style={{fontWeight:'600', textDecoration:'underline'}} colSpan="2" >DAY 1: 21ST JUNE 2023</th>
             
            </tr>
          
          </thead>
          <thead>
            <tr>
              <th style={{fontWeight:'bold', textDecoration:'none', backgroundColor: "white", color: "black"}} colSpan="2" >PRELIMINARIES, OVERVIEW OF DEVELOPMENTS AND EMERGING ISSUES RELATED TO ACCELERATED ECONOMIC GROWTH AND DEVELOPMENT FOR ASALS IN KENYA</th>
             
            </tr>
          
          </thead>
          <tbody>
            <tr>
              <td style={{fontWeight:"bold"}}>7.45 - 8.15</td>
              <td>Arrival and Registration</td>
            </tr>
            <tr>
              <td style={{fontWeight:"bold"}}>8.15 - 8.30</td>
              <td>ENTERTAINMENT<br />
                    PRAYERS<br />
                        NATIONAL AND EAST AFRICAN COMMUNITY ANTHEMS
</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th style={{fontWeight:'600'}} colSpan="2" >OPENING REMARKS</th>
             
            </tr>
          
          </thead>
          <tbody>
            <tr>
              <td style={{fontWeight:"bold"}}>8.30 – 10.00</td>
              <td style={{fontWeight:"normal"}}>Conference Overview: Setting stage for Accelerating Economic<br />
                                             Growth and Development for ASALs<br /> <br />
                                             ASALs areas and pockets in Kenya <br /> <br />
                                             Status of Development in ASALs <br /> <br />
                                             <span style={{color:"rgb(16, 187, 16)", fontStyle: "italic", fontWeight:"bold"}}>Interlude with short video clip </span> <span style={{fontWeight: "400", color: "black"}}>(2 Minutes)</span> <br /> <br />
                                             State, Non-State Actors and Development Partners in development <br />
                                             of ASAL areas <br /> <br /> <br />
                                             <span style={{fontWeight: "400", color: "black", fontStyle: "italic"}}>Plenary - 30 Minutes</span>
                                             </td>
            </tr>
            <tr>
              <td style={{fontWeight:"bold"}}>10.00 - 10.30</td>
              <td style={{fontWeight:"bold"}}> REFRESHMENT BREAK</td>
            </tr>
            <tr>
              <td style={{fontWeight:"bold"}}>10.00 - 16.30</td>
              <td style={{fontWeight:"bold", color:"red"}}> YOUTH’S PARALLEL EVENT</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th style={{fontWeight:'600'}} colSpan="2" >THEME 1:  ECONOMIC SYSTEMS IN ASALS</th>
             
            </tr>
          
          </thead>
          <thead>
            <tr>
              <th style={{fontWeight:'bold', backgroundColor: "white", color: "black"}} colSpan="2" >PLENARY SESSION 1.1 – Overview of Economic systems in ASAL</th>
             
            </tr>
          
          </thead>
          <tbody>
            <tr>
              <td style={{fontWeight:"bold"}}>10.30 - 12.40</td>
              <td style={{fontWeight:"normal"}}>Land Tenure System in ASALs<br /> <br />
              The Role of Pastoralism Economy and in the ASALs   <br /> <br />
              Tapping Indigenous Knowledge and the Role of Social Systems in Propelling <br /> 
              Economic Growth in ASALs<br /> <br />
                                                Climate Change Adaptation and Mitigation <br /> <br />
                                             <span style={{fontWeight: "400", color: "black", fontStyle: "italic"}}>Plenary for all the presentations - 45 minutes</span>
                                             </td>
            </tr>
            <tr>
              <td style={{fontWeight:"bold"}}>12.40 – 13.40</td>
              <td style={{fontWeight:"bold"}}>LUNCH BREAK</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th style={{fontWeight:'600'}} colSpan="2" >THEME 2:  INFRASTRUCTURE DEVELOPMENT</th>
             
            </tr>
          
          </thead>
          <thead>
            <tr>
              <th style={{fontWeight:'bold', backgroundColor: "white", color: "black"}} colSpan="2" >PLENARY SESSION 2.1 The Infrastructure Development in ASALs</th>
             
            </tr>
          
          </thead>
          <tbody>
            <tr>
              <td style={{fontWeight:"bold"}}>13.40 - 16.30</td>
              <td style={{fontWeight:"normal"}}>Transitioning to Clean Energy - Exploiting Solar and Wind Energy    <br /> <br />
              Access to Clean and Sufficient Water in ASALs  <br /> <br />
                                                The Role of Digital Economy in Supporting Growth in ASALs <br /> <br />
                                                Transport and accessibility of ASAL Areas (Road, Air, Water)<br /> <br /> <br />
                                             <span style={{fontWeight: "400", color: "black", fontStyle: "italic"}}>Chairs of the parallel sessions to present key highlights from their parallel sessions - 30 minutes</span>
                                             </td>
            </tr>
            <tr>
              <td style={{fontWeight:"bold"}}>16.30 - 16.45 </td>
              <td style={{fontWeight:"bold"}}>Refreshment, Entertainment and moving BAGS </td>
            </tr>
            <tr>
              <td style={{fontWeight:"bold"}}>16.45 - 18.00 </td>
              <td style={{fontWeight:"normal"}}>BREAK AWAY GROUPS (BAGS) PARALLEL PRESENTATIONS </td>
            </tr>
            <tr>
              <td style={{fontWeight:"bold"}}>19.00 - 21.00 </td>
              <td style={{fontWeight:"normal", fontStyle: "italic"}}>Dinner to launch of food security micro-simulation tool </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style={{marginTop: "20px"}}>
        <Footer />
      </div>
    </div>
  )
}

export default Day1;
